import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Landing from "@/pages/landing/page";
import TrackRequest from "@/pages/track/page";
import Login from "@/pages/login/page";
import ChangePasswordPage from "@/pages/change-password/page";
import ResetPasswordPage from "@/pages/reset-password/page";
import DashboardLayout from "@/components/feature/DashboardLayout";
import RequirePermission from "@/components/feature/RequirePermission";
import DashboardIndex from "@/components/feature/DashboardIndex";
import StudentsPage from "@/pages/dashboard/students/page";
import EnrollmentsPage from "@/pages/dashboard/enrollments/page";
import PaymentsPage from "@/pages/dashboard/payments/page";
import ClassesPage from "@/pages/dashboard/classes/page";
import FicheRenseignementsPage from "@/pages/dashboard/fiche/page";
import SubjectsPage from "@/pages/dashboard/subjects/page";
import TeachersPage from "@/pages/dashboard/teachers/page";
import StaffPage from "@/pages/dashboard/staff/page";
import FinancePage from "@/pages/dashboard/finance/page";
import RevenuePage from "@/pages/dashboard/revenue/page";
import ExpensesPage from "@/pages/dashboard/expenses/page";
import ReportsPage from "@/pages/dashboard/reports/page";
import GuardiansPage from "@/pages/dashboard/guardians/page";
import UnpaidPage from "@/pages/dashboard/unpaid/page";
import CashPage from "@/pages/dashboard/cash/page";
import TreasuryPage from "@/pages/dashboard/treasury/page";
import ClosingsPage from "@/pages/dashboard/closings/page";
import GradesPage from "@/pages/dashboard/grades/page";
import ReportCardsPage from "@/pages/dashboard/report-cards/page";
import UsersPage from "@/pages/dashboard/users/page";
import ActivityPage from "@/pages/dashboard/activity/page";
import SettingsPage from "@/pages/dashboard/settings/page";
import AccountPage from "@/pages/dashboard/account/page";
import PlatformPage from "@/pages/dashboard/platform/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Landing />,
  },
  {
    // Ancienne page de configuration : tout se règle désormais dans Paramètres, Classes et Matières.
    path: "/configuration",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    // Page publique de suivi : le visiteur vérifie l'état de sa demande avec sa référence.
    path: "/suivre-demande",
    element: <TrackRequest />,
  },
  {
    // Mot de passe provisoire : à remplacer avant tout accès.
    path: "/changer-mot-de-passe",
    element: <ChangePasswordPage />,
  },
  {
    // Lien « Mot de passe oublié » reçu par e-mail.
    path: "/reinitialiser-mot-de-passe",
    element: <ResetPasswordPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      { index: true, element: <DashboardIndex /> },
      { path: "platform", element: <RequirePermission permission="platform:read"><PlatformPage /></RequirePermission> },
      { path: "students", element: <RequirePermission permission="students:read"><StudentsPage /></RequirePermission> },
      { path: "guardians", element: <RequirePermission permission="guardians:read"><GuardiansPage /></RequirePermission> },
      { path: "enrollments", element: <RequirePermission permission="enrollments:read"><EnrollmentsPage /></RequirePermission> },
      { path: "payments", element: <RequirePermission permission="payments:read"><PaymentsPage /></RequirePermission> },
      { path: "unpaid", element: <RequirePermission permission="reminders:read"><UnpaidPage /></RequirePermission> },
      { path: "fiche", element: <RequirePermission permission="fees:read"><FicheRenseignementsPage /></RequirePermission> },
      { path: "classes", element: <RequirePermission permission="classes:read"><ClassesPage /></RequirePermission> },
      { path: "subjects", element: <RequirePermission permission="subjects:read"><SubjectsPage /></RequirePermission> },
      { path: "teachers", element: <RequirePermission permission="teachers:read"><TeachersPage /></RequirePermission> },
      { path: "staff", element: <RequirePermission permission="staff:read"><StaffPage /></RequirePermission> },
      { path: "finance", element: <RequirePermission anyOf={["revenues:read", "expenses:read"]}><FinancePage /></RequirePermission> },
      { path: "revenue", element: <RequirePermission permission="revenues:read"><RevenuePage /></RequirePermission> },
      { path: "expenses", element: <RequirePermission permission="expenses:read"><ExpensesPage /></RequirePermission> },
      { path: "treasury", element: <RequirePermission permission="treasury:read"><TreasuryPage /></RequirePermission> },
      { path: "cash", element: <RequirePermission permission="cash:read"><CashPage /></RequirePermission> },
      { path: "closings", element: <RequirePermission permission="closings:read"><ClosingsPage /></RequirePermission> },
      { path: "grades", element: <RequirePermission permission="grades:read"><GradesPage /></RequirePermission> },
      { path: "report-cards", element: <RequirePermission permission="report-cards:read"><ReportCardsPage /></RequirePermission> },
      { path: "reports", element: <RequirePermission permission="reports:read"><ReportsPage /></RequirePermission> },
      { path: "users", element: <RequirePermission permission="users:read"><UsersPage /></RequirePermission> },
      { path: "activity", element: <RequirePermission anyOf={["activity:read", "platform:read"]}><ActivityPage /></RequirePermission> },
      { path: "settings", element: <RequirePermission permission="settings:read"><SettingsPage /></RequirePermission> },
      { path: "account", element: <AccountPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;